import React from 'react';
import './ClientPage.css';

import { Heading, PageTitle } from '../../../components';
import { clients } from '../../../constants';



const ClientPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Clients'} page={'Clients'} />

      <section className='clients'>

        {/* Section heading */}
        <Heading title={'Our Clients'} subTitle={'Valued Client Partners'} />

        <div className='box-container'>

          {/* Loop through the Clients array to display each Client's logo */}
          {clients.map((client, index) => {
            return (
              <div className='client-item' key={index}>
                {/* Render the Client logo */}
                <img src={client} alt='Client Logo' />
              </div>
            );
            })
          }

        </div>

      </section>

    </>
  );
}

export default ClientPage;